import React, { useEffect, useRef, useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import logo from "../../assets/img/logoWithStroke.png";

type Props = {
  value: string;
  size?: number;
  canvasRef?: React.RefObject<HTMLCanvasElement>;
  includeMargin?: boolean;
  marginSize?: number;
};

const QRCodeWithLogo: React.FC<Props> = ({ value, size = 96, canvasRef, includeMargin = true, marginSize = 0 }) => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [dataUrl, setDataUrl] = useState<string | null>(null);
  const [logoLoaded, setLogoLoaded] = useState(false);

  const displaySize = size;
  const realSize = 240;

  useEffect(() => {
    const img = new Image();
    img.src = logo;
    img.onload = () => setLogoLoaded(true);
  }, []);

  useEffect(() => {
    if (!logoLoaded) return;

    const canvas = wrapperRef.current?.querySelector("canvas");
    if (!canvas) return;

    // Assign canvasRef for download function (always)
    if (canvasRef) {
      (canvasRef as React.MutableRefObject<HTMLCanvasElement | null>).current = canvas;
    }

    // Resize logic
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    const imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);

    canvas.width = realSize;
    canvas.height = realSize;

    const tmpCanvas = document.createElement("canvas");
    tmpCanvas.width = imgData.width;
    tmpCanvas.height = imgData.height;
    const tmpCtx = tmpCanvas.getContext("2d");
    tmpCtx?.putImageData(imgData, 0, 0);
    ctx.drawImage(tmpCanvas, 0, 0, realSize, realSize);
    setDataUrl(canvas.toDataURL("image/png"));
  }, [value, logoLoaded]);

  return (
    <div style={{ width: displaySize, height: displaySize, position: "relative" }}>
      {dataUrl && (
        <img
          src={dataUrl}
          alt="QR"
          style={{
            width: displaySize,
            height: displaySize,
            borderRadius: 8,
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: 2,
          }}
        />
      )}

      <div
        ref={wrapperRef}
        style={{
          width: displaySize,
          height: displaySize,
          position: "absolute",
          top: 0,
          left: 0,
          display: "none",
        }}
      >
        <QRCodeCanvas
          value={value}
          size={realSize}
          level="H"
          includeMargin={includeMargin}
          marginSize={marginSize}
          style={{
            width: displaySize,
            height: displaySize,
          }}
          imageSettings={{
            src: logo,
            height: displaySize * 0.6,
            width: displaySize * 0.6,
            excavate: false,
            crossOrigin: "anonymous",
          }}
        />
      </div>
    </div>
  );
};

export default QRCodeWithLogo;
